export default __webpack_public_path__ + "static/media/image15.33e6bc7c.jpg";